var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImageNotSupported(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.8999 19.9001L13.4099 11.4101L3.58994 1.5901L2.09994 0.100098L0.689941 1.5101L2.99994 3.8301V17.0001C2.99994 18.1001 3.89994 19.0001 4.99994 19.0001H18.1699L20.4799 21.3101L21.8999 19.9001ZM4.99994 16.0001L8.49994 11.5001L10.9999 14.5101L12.1699 13.0001L15.1699 16.0001H4.99994ZM20.9999 16.1701L5.82994 1.0001H18.9999C20.0999 1.0001 20.9999 1.9001 20.9999 3.0001V16.1701Z",
    fill: "#003a70"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageNotSupported);
export default __webpack_public_path__ + "static/media/imageNotSupported.a099af6651aec9cfabecfb35a39bd24b.svg";
export { ForwardRef as ReactComponent };